<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<!--page-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading"></div>
      <div class="card-body">
        <h3 class="title">شرایط و قوانین هشتگ بیمه</h3>
        <br>
        <p>
          کاربر محترم لطفاً موارد زیر را جهت استفاده بهینه از خدمات هشتگ بیمه به دقت مطالعه فرمائید. استفاده از تمامی
          خدمات هشتگ بیمه، به معنای آگاه بودن و پذیرفتن شرایط و قوانین استفاده از خدمات می‌باشد. کلیه اصول، فرآیندها،
          محتواها و خدمات ارائه شده در هشتگ بیمه منطبق با قوانین جمهوری اسلامی ایران، قانون تجارت ایران، قانون تجارت
          الکترونیک و قانون حمایت از حقوق مصرف کننده می‌باشد و متعاقبا کاربر نیز موظف به رعایت قوانین مرتبط با کاربر
          است، بنابراین عمل به قوانین و مقررات سایت به عنوان یک قرارداد الزامی است.
        </p>
        <br>
        <h4>تعاریف</h4>
           <h5>تعریف کاربر یا بیمه‌گذار </h5>
            <p> کاربر یا بیمه‌گذار به فردی اطلاق می شود که با اطلاعات شخصی خود نسبت خرید آنلاین بیمه
              در هشتگ بیمه اقدام
              نماید. شخصی که در هشتگ بیمه با استفاده از اطلاعات خود نسبت به ثبت درخواست، خرید یا دریافت خدمات برای شخص
              سومی اقدام می‌کند، نیز از طرف هشتگ بیمه به عنوان کاربر یا بیمه گذار شناخته شده و ملزم به رعایت تمامی
              قوانین هشتگ بیمه می‌باشد.</p>
          <h5>تعریف بیمه‌گر </h5>
            <p>بیمه‌گر شخصی حقوقی است، که برای ارائه خدمات و محصولات بیمه‌ای، دارای مجوز رسمی از "بیمه
              مرکزی جمهوری
              اسلامی ایران" می‌باشد و در مقابل دریافت حق بیمه از بیمه‌گذار، تعهد جبـران خسارات و یا پرداخت غرامات ناشي
              از حوادث احتمالي طبق شرايط مقــرر در بيمه‌نامه را به عهده مي‌گيرد.</p>
          <h5>خدمات هشتگ بیمه </h5>
            <p>به هرگونه خدمتی اعم از مشاوره، بیمه نامه و ... اطلاق می شود که توسط هشتگ بیمه در
              ازای دریافت وجهی به
              کاربر ارائه می شود همچنین قابل توجه می باشد که تمامی قیمت‌های ارائه شده در هشتگ بیمه از طرف بیمه گر اعلام
              می‌شود و هشتگ بیمه هیچ گونه دخل و تصرفی در قیمت ها ندارد. انصراف از دریافت بیمه‌نامه منوط به قوانین داخلی
              شرکت صادرکننده‌ی بیمه می‌باشد.</p>
         <h4>حریم شخصی</h4>
        <p>هشتگ بیمه متعهد است در حد توان از حریم شخصی شما محافظت نماید و از جدیدترین تکنولوژی‌های موجود جهت حفظ اطلاعات
          شما استفاده نماید. تمامی مطالب ارائه شده توسط هشتگ بیمه به عنوان اموال هشتگ بیمه محسوب می‌شود و حق هر گونه
          استفاده از آنها در انحصار هشتگ بیمه می‌باشد</p>
        <h4>انصراف از خرید</h4>
        <p>کاربر می‌تواند در هر مرحله قبل از پرداخت مبلغ بیمه‌نامه، از خرید خود انصراف دهد. چنانچه درخواست انصراف پس از
          پرداخت مبلغ بیمه از طرف بیمه گذار اعلام شود و بیمه درخواستی مشتری هنوز صادر نشده باشد، هشتگ بیمه موظف است
          تمامی مبالغ پرداختی را به مشتری عودت دهد. در صورتی که بیمه درخواستی مشتری صادر شده باشد، عودت وجه منوط به قبول
          شرکت بیمه جهت ابطال بیمه خواهد بود، در غیر این صورت عودت وجه مقدور نمی‌باشد.</p>
        <h4>مدت قرارداد</h4>
        <p>از لحظه ورود کاربر با نام کاربری اختصاصی خود، کاربر می‌تواند از خدمات هشتگ بیمه استفاده نماید. ورود کاربر به
          معنی قبول همکاری با هشتگ بیمه می‌باشد. کاربر می‌تواند در هر لحظه از حساب کاربری خود خارج شود اما
          این موضوع به منزله انصراف از همکاری با هشتگ بیمه نمی‌باشد. جهت خاتمه‌ی همکاری کاربر می‌تواند درخواست خود را به
          هشتگ بیمه اعلام نماید. </p>
        <h4>تماس با هشتگ بیمه</h4>
        <p>راه های ارتباطی رسمی هشتگ بیمه ازطریق شماره تماس، سامانه پیامکی، ایمیل و یا شبکه‌های اجتماعی که در قسمت تماس
          با ما درج شده، می باشد. و هشتگ بیمه فقط از طریق این سامانه‌ها به ارتباط با کاربر می‌پردازد و هر گونه تماس از
          راه های دیگر سوء استفاده از نام هشتگ بیمه محسوب می شود و تحت پیگرد قانونی قرار می‌گیرد.</p>
        <h4>ارسال سفارش</h4>
        <p>با توجه به اینکه خرید محصولات بیمه ای که توسط هشتگ بیمه ارائه می شود بصورت کاملا آنلاین می باشد بنابراین بیمه
          نامه آن نیز بصورت آنلاین در اختیار کاربر قرار خواهد گرفت و کاربر می تواند از طریق بیمه های من در هشتگ بیمه آن
          را دانلود و استفاده نماید. در صورتی که کاربری نیاز به بیمه نامه فیزیکی داشته باشد می تواند با ارسال ایمیل به
          support@hashtagbime.com و یا تماس تلفنی درخواست خود را جهت دریافت فیزیکی بیمه نامه اعلام نماید.</p>
        <h4>شرایط صدور</h4>
           <h5>بیمه درمان تکمیلی خانواده</h5>
               <p>بعد از ثبت درخواست بیمه درمان تکمیلی انفرادی پزشک متعد اطلاعات سلامت را بررسی نموده و نتیجه به کاربر اعلام می گردد</p>
              <p>در صورت تایید پزشک واحد صدور ( نماینده بیمه ) بیمه نامه کاربر را صدور می نماید.</p>
              <p>در صورتیکه اعضای یک خانواده  بیمه درمان تکمیلی خانواده را درخواست نمایند صدور بیمه نامه بعد از مشخص شدن وضعیت تمام اعضا انجام خواهد شد.</p>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
